import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
const events = [{
  title: 'Front Line Patrol Leadership and Training',
  link: '/law-enforcement-capabilities'
}, {
  title: 'Instructor Development and Education',
  link: '/training'
}, {
  title: 'Advanced Tactical Training',
  link: '/about-apc'
}];
export function EventsSection() {
  return <section className="py-16 md:py-24 lg:py-32 relative tactical-grid" data-id="element-565">
      <div className="absolute inset-0 bg-brand-black/90 z-0" data-id="element-566" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-567">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-16 gap-6" data-id="element-568">
          <div className="mb-0" data-id="element-569">
            <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-570">
              Upcoming Training Events
            </h2>
            <div className="w-16 h-0.5 bg-brand-teal" data-id="element-571" />
          </div>
          <a href="/training" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light px-6 py-3 text-sm gap-2" data-id="element-572">
            <Calendar className="w-4 h-4" data-id="element-573" />
            View Calendar
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-574">
          {events.map((event, i) => <div key={i} className="group border border-brand-gray-800 bg-brand-black p-6 hover:border-brand-teal transition-colors flex flex-col" data-id="element-575">
              <div className="text-xs font-bold text-brand-teal uppercase tracking-widest mb-4 flex items-center gap-2" data-id="element-576">
                <span className="w-2 h-2 bg-brand-teal rounded-sm" data-id="element-577" />
                Featured Course
              </div>
              <h3 className="text-xl font-bold text-brand-white mb-6 uppercase leading-snug flex-grow" data-id="element-578">
                {event.title}
              </h3>
              <a href={event.link} className="inline-flex items-center text-brand-gray-400 font-bold uppercase tracking-wider text-sm group-hover:text-brand-teal transition-colors" data-id="element-579">
                Learn More{' '}
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-580" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}